import { z } from "zod/v4";
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { Stack, Typography } from "@mui/material";
import { Form, FormProps, useFormContext } from "@/components/form";

export const initialMonetizacionFormSchema = z.object({
    monedas: z.array(z.object({
        nombre: z.string().nonempty("Este campo es requerido"),
        simbolo: z.string().nonempty("Este campo es requerido"),
        base: z.boolean(),
        relacionConBase: z.number({ message: "Este campo es requerido" }).gt(0, { message: "El valor debe ser mayor a 0" })
    })).min(1, "Debe definirse por lo menos una moneda").refine(v => v.filter(d => d.base).length == 1, {
        message: "Solo debe haber una moneda base",
        path: ["monedas"]
    })
})

export default function InitialMonetizacionForm({
    form,
    ...props
}: FormProps<z.input<typeof initialMonetizacionFormSchema>>) {
    return <Form form={form as any} gap={3} {...props}>
        <form.Field name="monedas" mode="array">
            {(field) => <>
                {field.state.value.map((_, i) => i == 0 ?
                    <MonedaPrincipalField key={i} /> :
                    <MonedaSetField key={i} index={i} onRemove={() => form.removeFieldValue("monedas", i)} />
                )}
                <Form.Button
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={() => {
                        if (field.state.value.length <= 0) {
                            field.pushValue({
                                nombre: "",
                                simbolo: "",
                                base: true,
                                relacionConBase: 1
                            })
                        } else {
                            field.pushValue({
                                nombre: "",
                                simbolo: "",
                                base: false,
                                relacionConBase: "" as unknown as number
                            })
                        }
                    }}
                >Nueva Moneda</Form.Button>
            </>}
        </form.Field>
        <Form.SubmitButton>
            Aplicar
            <Form.ErrorText name="monedas" />
        </Form.SubmitButton>
    </Form>
}

function MonedaSetField({
    index,
    onRemove
}: {
    onRemove: () => void,
    index: number
}) {
    const form = useFormContext();

    return <Stack gap={2} direction={"row"} alignItems={"center"}>
        <Stack flex={2}>
            <Form.TextField name={`monedas[${index}].nombre`} label="Moneda" />
        </Stack>
        <Stack flex={1}>
            <Form.TextField name={`monedas[${index}].simbolo`} label="Símbolo" />
        </Stack>
        <Stack flex={1}>
            <form.Subscribe selector={state => state.values.monedas}>
                {monedas => <Form.NumberField
                    name={`monedas[${index}].relacionConBase`}
                    label="Valor"
                    alignRight
                    slotProps={{
                        input: {
                            endAdornment: <Typography textAlign={"right"} whiteSpace={"nowrap"}>
                                &nbsp;{monedas[0]?.simbolo}
                            </Typography>
                        }
                    }}
                    decimalScale={10}
                />}
            </form.Subscribe>
        </Stack>
        <Form.IconButton onClick={onRemove}>
            <CloseIcon />
        </Form.IconButton>
    </Stack>
}

function MonedaPrincipalField() {
    return <Stack gap={2} direction={"row"} alignItems={"center"}>
        <Stack flex={2}>
            <Form.TextField name={`monedas[0].nombre`} label="Moneda Principal" />
        </Stack>
        <Stack flex={0.5}>
            <Form.TextField name={`monedas[0].simbolo`} label="Símbolo" />
        </Stack>
    </Stack>
}